import ReactHtmlParser from "react-html-parser";
import { transform } from "helpers/transformNodeHelper";

function Paragraph({ data }) {
  const html = ReactHtmlParser(data.text, { transform });
  return <p>{html}</p>;
}

export { Paragraph };
